import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {ListsHttpService} from '../../../../../services/http-services/lists/lists-http.service';
import {ItemsHelperService} from '../../../../../services/helpers/items-helper.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../../constants/pages-and-paths';
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-suggested-columns',
  standalone: true,
    imports: [
        NgForOf,
        NgIf,
        FormsModule,
      TranslateModule
    ],
  templateUrl: './suggested-columns.component.html',
})
export class SuggestedColumnsComponent implements OnInit {
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() dataLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() refreshPage: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() listId!: number;
  columns: string[] = [];
  selectedColumns: string[] = [];
  filteredColumns: string[] = [];
  areColumnsLoading = false;
  searchTerm = '';

  constructor(
    private listsHttpService: ListsHttpService,
    private itemsHelperService: ItemsHelperService,
    private toastrService: ToastrService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.areColumnsLoading = true;
    this.dataLoading.emit(true);
    this.getSuggestedColumns(this.listId);
  }

  getSuggestedColumns(listId: number): void {
    this.listsHttpService.getSuggestedLists(listId).subscribe((response: any) => {
      this.columns = response.data;
      this.filteredColumns = [...this.columns];
      this.areColumnsLoading = false;
      this.dataLoading.emit(false);
    }, (err: any) => {
      this.areColumnsLoading = false;
      this.dataLoading.emit(false);
    });
  }

  onCheckboxChange(event: any, column: string): void {
    if (event.target.checked) {
      if (!this.selectedColumns.includes(column)) {
        this.selectedColumns.push(column);
      }
    } else {
      this.selectedColumns = this.selectedColumns.filter(item => item !== column);
    }
  }

  saveColumns(): void {
      this.listsHttpService.postListColumn({name: this.selectedColumns}, this.listId).then((response: any) => {
        this.toastrService.success(response.message);
        this.refreshPage.emit(true);
        this.router.navigate([PAGES_AND_PATHS.singleList.pagePath, this.listId, 'table']);
        this.closeModal.emit();
      });
  }

  filterColumns(): void {
    this.filteredColumns = this.columns.filter(column =>
      column.toLowerCase().includes(this.searchTerm)
    );
  }

}
